import InternalCheckbox from './Checkbox';
import Group from './Group';
import './style/index';
var Checkbox = InternalCheckbox;
Checkbox.Group = Group;
Checkbox.__ANT_CHECKBOX = true;
export default Checkbox;